import React from 'react';
import img000 from '../components/images/sample.png';
import img2051 from '../components/images/rglowroad.jpg';

const Events = () => {
    return (
        <>
            <div className="row m-2">
                <img className="img-fluid" src={img2051} alt="glowroad" />
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <h2>Why Register for GlowRoad?</h2>
                        <p>
                            <strong>Registering on GlowRoad</strong> connects you with a vast network of resellers and customers,
                            helping you expand your business reach and boost sales effortlessly.
                        </p>
                    </div>
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src={img000} alt="Queryimg" />
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12 col-md-6">
                        <h2>Essential Details Required:</h2>
                        <ul className="list-group">
                            <li className="list-group-item"><strong>Email ID:</strong> For account setup and communication.</li>
                            <li className="list-group-item"><strong>Contact Number:</strong> Needed for verification and customer support.</li>
                            <li className="list-group-item"><strong>GST Certificate:</strong> Mandatory for compliance and to start selling.</li>
                            <li className="list-group-item"><strong>Pickup Address:</strong> Required for product collection and order fulfillment.</li>
                            <li className="list-group-item"><strong>Bank Details:</strong> To facilitate secure and timely payments.</li>
                            <li className="list-group-item"><strong>Product Category:</strong> To ensure your products are listed in the appropriate categories.</li>
                            <li className="list-group-item"><strong>Amazon Account:</strong> May be required if integrated selling is involved (please confirm).</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src={img000} alt="Queryimg" />
                    </div>
                </div>

                <p className="mt-4">
                    <strong>Take your business to new heights</strong> with GlowRoad. Contact E Seller Support for expert assistance in getting started.
                </p>
            </div>
        </>
    );
};

export default Events;
